// extracted by mini-css-extract-plugin
export default {"root":"Textarea_root__V5YdC","input":"Textarea_input__qqZN+","label":"Textarea_label__Tp8K6"};